var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-8"},[_c(_vm.getAgTela,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }